import { BIModel } from './BIModel';

export class UserAlertConfigureBIModel extends BIModel {

  static eventName = 'user_alert_configure';

  #action;
  #type;

  constructor(userId, action, type) {
    super(UserAlertConfigureBIModel.eventName, userId);
    this.#action = action;
    this.#type = type;
  }

  get action() {
    return this.#action;
  }

  get type() {
    return this.#type;
  }

  get modelData() {
    return {
      action: this.action,
      type: this.type,
    };
  }

}